
import { HashLink as Link } from 'react-router-hash-link';
import React  from 'react'
import Trusted from '../HomeMain/Trusted/Main'
import Features from '../HomeMain/Features/Main'
import AboutApp from '../HomeMain/AboutApp/Main'
import Design from '../HomeMain/Design/Main'
import Work from '../HomeMain/Work/Main'
import Testimonial from '../HomeMain/Testimonial/Main'
import Faq from '../HomeMain/Faq/Main'
import Interface from '../HomeMain/Interface/Main'
import Download from '../HomeMain/Download/Main'
import Story from '../HomeMain/Story/Main'

const Main = ({setnavbar , setfooter , setbrdcum }) => {

    return (
        <>
            <section className="banner_section home-wave">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12"  data-aos-duration="1500">
                            <div className="banner_text">
                                <h1>Inspections, Items, Equipment, Documents, Handovers, Workpacks, Punches....</h1>
                                <p>You name it, we store and track it, fully audited inspections, punches, handover certification, ATEX and alot more! Did someone say <strong>AI?</strong>
                                </p>
                                <p>Accord uses the latest technology and that mean's we've integrated <strong className={'text-xl'}>AI</strong>, Ask AI about your data: "how many inspections done today"</p>
                            </div>
                            <ul className="app_btn">
                                <li>
                                    <Link to="#">
                                        <img className="blue_img" src="/assets/images/appstore_blue.png" alt="appstore_blue" />
                                        <img className="white_img" src="/assets/images/appstore_white.png" alt="appstore_white" />
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#">
                                        <img className="blue_img" src="/assets/images/googleplay_blue.png" alt="googleplay_blue" />
                                        <img className="white_img" src="/assets/images/googleplay_white.png" alt="googleplay_white" />
                                    </Link>
                                </li>
                            </ul>
                            <div className="used_app">
                                <ul>
                                    <li><img src="/assets/images/used01.png" alt="used01" /></li>
                                    <li><img src="/assets/images/used02.png" alt="used02" /></li>
                                    <li><img src="/assets/images/used03.png" alt="used03" /></li>
                                    <li><img src="/assets/images/used04.png" alt="used04" /></li>
                                </ul>
                                <p>12M + <br/> used this app</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12"   data-aos-duration="1500">
                            <div className="banner_image">
                                <img className="moving_animation" src="/assets/images/banner-image.png" alt="banner" />
                            </div>
                        </div>

                        <span className="banner_shape1"> <img src="/assets/images/banner-shape1.png" alt="shape1" /> </span>
                        <span className="banner_shape2"> <img src="/assets/images/banner-shape2.png" alt="shape2" /> </span>
                        <span className="banner_shape3"> <img src="/assets/images/banner-shape3.png" alt="shape3" /> </span>
                    </div>

                </div>
                <div className="home-wave-bottom">
                    <svg className="waves" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
                         viewBox="0 24 150 28" preserveAspectRatio="none" shapeRendering="auto">
                        <defs>
                            <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                        </defs>
                        <g className="parallax">
                            <use xlinkHref="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
                            <use xlinkHref="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                            <use xlinkHref="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#f6f4fe" />
                        </g>
                    </svg>
                </div>
            </section>
            <Trusted />
            <Features />
            <AboutApp />
            <Design />
            <Work />
            <Testimonial />
            <Faq/>
            <Interface/>
            <Download />
            <Story/>
        </>
    )
}

export default Main